import { CheckIcon, CloseIcon } from '@trading-ui/icons';

import i18n from '@/i18n/config';

import type { Action } from '@/interfaces/app.interfaces';

type Params = {
  handleChangeActionStatus: (actionId: number, statusId: number) => void;
  setMoeveUserActionId: (actionId: number | null) => void;
};

const transformType = (value: string) => {
  switch (value) {
    case 'CREATE_COMPANY':
      return i18n.t('settings.moeveActionsTab.pendingActions.types.createCompany');
    case 'CREATE_PLANT':
      return i18n.t('settings.moeveActionsTab.pendingActions.types.createCups');
    case 'CREATE_MOEVE_USER':
    case 'CREATE_MOEVE_ADMIN':
      return i18n.t('settings.moeveActionsTab.pendingActions.types.createMoeveUser');
    default:
      return value;
  }
};

const iconCellStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  cursor: 'pointer',
  backgroundColor: 'rgba(4, 120, 178, 0.2)',
  color: '#0478B2',
};

export function getActionsColumns({ handleChangeActionStatus, setMoeveUserActionId }: Params) {
  return [
    {
      Header: i18n.t('settings.moeveActionsTab.pendingActions.columns.type'),
      accessor: 'type',
      width: 50,
      Cell: ({ value }: { value: string }) => <span>{transformType(value)}</span>,
    },
    {
      Header: i18n.t('settings.moeveActionsTab.pendingActions.columns.company'),
      accessor: 'company.name',
      width: 70,
    },
    {
      Header: i18n.t('settings.moeveActionsTab.pendingActions.columns.action'),
      accessor: 'description',
      width: 300,
    },
    {
      Header: '',
      accessor: 'approve',
      width: 40,
      cellStyle: () => iconCellStyle,
      Cell: ({ row }: { row: { original: Action } }) => (
        <CheckIcon
          size={24}
          className="icon-hover"
          onClick={
            row.original.type === 'CREATE_MOEVE_USER' || row.original.type === 'CREATE_MOEVE_ADMIN'
              ? () => setMoeveUserActionId(row.original.id)
              : () => handleChangeActionStatus(row.original.id, 2)
          }
        />
      ),
    },
    {
      Header: '',
      accessor: 'reject',
      width: 40,
      cellStyle: () => iconCellStyle,
      Cell: ({ row }: { row: { original: Action } }) => (
        <CloseIcon size={24} className="icon-hover" onClick={() => handleChangeActionStatus(row.original.id, 3)} />
      ),
    },
  ];
}
